<template>
  <b-container id="home-margin" class="my-4">
    <b-row>
      <b-col>
        <div id="home-title">Welcome to my playground</div>
        <div style="text-align:center">Here you can explore and play around with some of my hobby projects.</div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col lg="8">
        <h2>About me</h2>
        <p>
          I am a theoretical physicist with a PhD in mathematical models of human behavior and
          with expertise in the area of deep learning and data science.
        </p>
        <p>
          For the past couple of years, I have worked as a combination of machine learning engineer and
          full stack software developer. This is a great cocktail for doing fun projects, so I will share
          some of them with you here. I have bought the cheapest server on the internet, so naturally that
          limits my applications to small models and provides for an interesting challenge.
        </p>
        <p>
          I thoroughly enjoy applying math and data crunching to real world problems in the search
          of a better understanding and to improve decision making. On this homepage I intend to show off some
          of my skills, while hopefully having a lot of fun along the way 😃
        </p>
      </b-col>
      <b-col cols="12" lg="4">
        <div id="contact-box">
          <img id="my-image" src="./assets/me.jpg">
          <div><em>Anders Lykke Møllgaard</em></div>
          <div>anders.mollgaard@gmail.com</div>
          <a href="https://scholar.google.dk/citations?user=A1c7HBAAAAAJ&hl=en"
              target="_blank" style="display:block">Google Scholar</a>
          <a href="https://www.linkedin.com/in/anders-edsberg-moellgaard/"
              target="_blank" style="display:block">LinkedIn</a>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "home.vue"
};
</script>

<style scoped>
  #home-title {
    text-align: center;
    font-size: 35px;
  }
  #contact-box {
    padding: 20px 0 20px 0;
    text-align: center;
    background-color: white;
    border: 2px solid gainsboro;
    border-radius: 10px;
    margin-bottom: 10px;
  }
  #my-image {
    margin-bottom: 15px;
    width: 65%;
    border-radius: 10px;
  }
</style>
